import { useChatStore } from '../../store/chatStore';
import { PanelLeftClose, PanelLeft, Search, ShieldCheck, Network } from 'lucide-react';

interface ChatHeaderProps {
  guardrailsTestMode?: boolean;
  onToggleGuardrailsTest?: () => void;
}

/** Top header bar with sidebar toggle, ripgrep search, and guardrails test toggle. */
export function ChatHeader({ guardrailsTestMode, onToggleGuardrailsTest }: ChatHeaderProps) {
  const { isSidebarOpen, toggleSidebar, toggleRipgrepPanel, showRipgrepPanel } = useChatStore();

  return (
    <header className="h-14 border-b border-gray-200 flex items-center justify-between px-4 bg-white flex-shrink-0">
      <div className="flex items-center gap-3">
        <button
          onClick={toggleSidebar}
          className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
          aria-label={isSidebarOpen ? 'Close sidebar' : 'Open sidebar'}
        >
          {isSidebarOpen ? <PanelLeftClose size={20} /> : <PanelLeft size={20} />}
        </button>
        <h2 className="font-medium text-gray-800">LISA</h2>
      </div>

      <div className="flex items-center gap-2">
        <a
          href="#/graph-viz"
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm transition-colors border text-gray-600 hover:text-gray-800 hover:bg-gray-50 border-gray-200"
          aria-label="Open Graph Visualization"
        >
          <Network size={16} />
          <span className="hidden sm:inline">Graph Viz</span>
        </a>
        <button
          onClick={onToggleGuardrailsTest}
          className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm transition-colors border ${
            guardrailsTestMode
              ? 'bg-amber-50 text-amber-700 border-amber-200'
              : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50 border-gray-200'
          }`}
          aria-pressed={guardrailsTestMode}
          aria-label="Toggle Guardrails Test Mode"
        >
          <ShieldCheck size={16} />
          <span className="hidden sm:inline">Test Guardrails</span>
        </button>
        <button
          onClick={toggleRipgrepPanel}
          className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm transition-colors border ${
            showRipgrepPanel
              ? 'bg-primary-50 text-primary-700 border-primary-200'
              : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50 border-gray-200'
          }`}
          aria-pressed={showRipgrepPanel}
          aria-label="Toggle Ripgrep Search"
        >
          <Search size={16} />
          <span className="hidden sm:inline">Search</span>
        </button>
      </div>
    </header>
  );
}
